import { render } from "./CurriculumStructure.vue?vue&type=template&id=728c891d"
import script from "./CurriculumStructure.vue?vue&type=script&lang=js"
export * from "./CurriculumStructure.vue?vue&type=script&lang=js"

import "./CurriculumStructure.vue?vue&type=style&index=0&id=728c891d&lang=less"

import exportComponent from "/Users/wanglei/lnmp/www/study-report/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__